import React, { useState, useEffect } from 'react';
import './index.css';
import {
  FormGroup,
  Container,
  Col,
  Row,
  Input,
  Label,
  Form,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { editDealer } from '../../../constants/apiCalls';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import ModalService from '../../../services/ModalService';
import { DashBoardTitle } from '../../../Components/Title';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import swal from 'sweetalert';
import { CommonButton } from '../../../Components/CommonComponents';
import { handleErrorMessage } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { dealerInfoAction } from '../../../reducers/DealerReducer';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const PrimaryContactInformation = () => {
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);
  const initialValues = {
    primaryName: '',
    designation: '',
    email: '',
    primaryContact: '',
    primaryWhatsApp: '',
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [isActiveOwner, setIsActiveOwner] = useState(false);
  const [isMobileCheck, setIsmobileCheck] = useState(false);
  const [isKycRequired, setIsKycRequired] = useState(false);
  let location = useLocation();
  const [title, setTitle] = useState({});
  let stringArr = location.pathname.split(/(\d+)/);
  let userId = stringArr[1];

  const dispatch = useDispatch();
  const { dealerObj } = useSelector(state => state.DealerReducer);

  useEffect(() => {
    if (userId) {
      setIsloading(true);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    }
  }, [isActiveOwner]);

  useEffect(() => {
    setIsKycRequired(dealerObj.is_approved);
    setTitle({ name: dealerObj.business_name, page: dealerObj.page_8 });
    setFormValues({
      primaryName: dealerObj.primary_contact_name,
      designation: dealerObj.primary_contact_designation,
      email: dealerObj.primary_contact_email,
      primaryContact: dealerObj.primary_contact_mobile,
      primaryWhatsApp: dealerObj.primary_contact_whatsapp,
    });
    let getActiveOwner = dealerObj && dealerObj.owners && dealerObj.owners.length > 0 ? dealerObj.owners.filter(val => val.is_primary_contact === true) : [];
    if (getActiveOwner && getActiveOwner.length > 0 && isActiveOwner) {
      setFormValues({
        primaryName: getActiveOwner[0].name,
        designation: getActiveOwner[0].designation,
        email: getActiveOwner[0].email,
        primaryContact: getActiveOwner[0].mobile_number,
        primaryWhatsApp: getActiveOwner[0].whatsapp_mobile_number,
      });
    }
    if (isMobileCheck) {
      if (isActiveOwner) {
        setFormValues({
          primaryName: getActiveOwner[0].name,
          designation: getActiveOwner[0].designation,
          email: getActiveOwner[0].email,
          primaryContact: getActiveOwner[0].mobile_number,
          primaryWhatsApp: getActiveOwner[0].mobile_number,
        });
      } else {
        setFormValues({
          primaryName: dealerObj.primary_contact_name,
          designation: dealerObj.primary_contact_designation,
          email: dealerObj.primary_contact_email,
          primaryContact: dealerObj.primary_contact_mobile,
          primaryWhatsApp: dealerObj.primary_contact_mobile,
        });
      }
    }
  }, [dealerObj])

  const handleChange = (e, key) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSaveAsDraft = (evt) => {
    evt.preventDefault();
    let payload = {
      id: userId,
      primary_contact_name: formValues.primaryName,
      primary_contact_designation: formValues.designation,
      primary_contact_mobile: formValues.primaryContact,
      primary_contact_whatsapp:
        isMobileCheck === true
          ? formValues.primaryContact
          : formValues.primaryWhatsApp,
      primary_contact_email: formValues.email,
      page_8: 0,
    };
    setIsloading(true);
    editDealer((res) => {
      const { success, message, error } = res;
      if (success === true) {
        ModalService.openAlert('', message, 'success');
        setIsloading(false);
        setTimeout(() => {
          const lastRoute = Storage.backBreadcrumbsButton();
          navigate(lastRoute.url, { replace: true });
        }, 3000);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    if (formValues.email) {
      let regEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      if (!formValues.email || regEmail.test(formValues.email) === false) {
        swal('Invalid Email Address!!');
        return false;
      } else if (formValues.email && regEmail.test(formValues.email) === true) {
        // return true
      }
    }
    let payload = {
      id: userId,
      primary_contact_name: formValues.primaryName,
      primary_contact_designation: formValues.designation,
      primary_contact_mobile: formValues.primaryContact,
      primary_contact_whatsapp:
        isMobileCheck === true
          ? formValues.primaryContact
          : formValues.primaryWhatsApp,
      primary_contact_email: formValues.email,
      page_8: 1,
    };
    setIsloading(true);
    editDealer((res) => {
      const { success, message, error } = res;
      if (success === true) {
        ModalService.openAlert('', message, 'success');
        setIsloading(false);
        setTimeout(() => {
          const lastRoute = Storage.backBreadcrumbsButton();
          navigate(lastRoute.url, { replace: true });
        }, 3000);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const handleBack = () => {
    const lastRoute = Storage.backBreadcrumbsButton();
    navigate(lastRoute.url, { replace: true });
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='PrimaryContactInfo'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle
                          dashBorardName={
                            title.page === 1 ? title.name : 'New Dealer Registration'
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title='Primary Contact Information' />
                    </Col>
                  </Row>
                  <div className='PrimaryContactInfoBlock'>
                    <div className='PrimaryContactInfoBlockInner'>
                      <Row>
                        <Col xs={12}>
                          <div className='dealerRegBlocktitle text-center noprint'>
                            Primary Contact Information
                          </div>
                        </Col>
                      </Row>
                      <Form onSubmit={handleSubmit} id='create-course-form'>
                        <Row>
                          <Col xs={12}>
                            <div className='dealerRegBlocktitleInner labelTop'>
                              Primary Contact Information
                            </div>
                            <FormGroup className='common-checkbox-group'>
                              <Input
                                type='checkbox'
                                className='common-checkbox-input ml-0'
                                checked={isActiveOwner}
                                value={isActiveOwner}
                                onChange={(e) => setIsActiveOwner(!isActiveOwner)}
                              />
                              <Label className='common-input-label mb-0'>
                                Same as Active Owner Information
                                <span className='required'></span>
                              </Label>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <FormGroup className='name-info-group'>
                              <Label className='common-input-label'>
                                Name<span className='required'>*</span>
                              </Label>
                              <Input
                                required
                                className='common-input'
                                name='primaryName'
                                autoComplete='off'
                                onChange={(e) => {
                                  handleChange(e, 1);
                                }}
                                placeholder='Type Here'
                                value={
                                  formValues.primaryName === null ||
                                    formValues.primaryName === 'undefined'
                                    ? ''
                                    : formValues.primaryName
                                }
                                type='text'
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4}>
                            <FormGroup className='designation-info-group'>
                              <Label className='common-input-label'>
                                Designation<span className='required'>*</span>
                              </Label>
                              <Input
                                required
                                className='common-input'
                                name='designation'
                                autoComplete='off'
                                onChange={(e) => {
                                  handleChange(e, 2);
                                }}
                                placeholder='Type Here'
                                value={
                                  formValues.designation === null ||
                                    formValues.designation === 'undefined'
                                    ? ''
                                    : formValues.designation
                                }
                                type='text'
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row className='basic-business-main'>
                          <Col md={4}>
                            <Label className='common-input-label'>
                              Mobile Number<span className='required'>*</span>
                            </Label>
                            <FormGroup className='country-code-group'>
                              <Input
                                className='country-code-input'
                                type='text'
                                disabled
                                value='+91'
                              />
                              <div className='mobile-number w-100'>
                                <Input
                                  required
                                  className='common-input w-100'
                                  name='primaryContact'
                                  value={
                                    formValues.primaryContact === null ||
                                      formValues.primaryContact === 'undefined'
                                      ? ''
                                      : formValues.primaryContact
                                  }
                                  maxLength={10}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  autoComplete='off'
                                  onChange={(e) => {
                                    handleChange(e, 3);
                                  }}
                                  placeholder='Type Here'
                                  type='text'
                                />
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md={4}>
                            <Label className='common-input-label'>
                              Whatsapp Number<span className='required'>*</span>
                            </Label>
                            <FormGroup className='country-code-group'>
                              <Input
                                className='country-code-input'
                                type='text'
                                disabled
                                value='+91'
                              />
                              <div className='mobile-number w-100'>
                                <Input
                                  required
                                  className='common-input w-100'
                                  placeholder='Type Here'
                                  name='primaryWhatsApp'
                                  maxLength={10}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  autoComplete='off'
                                  value={
                                    isMobileCheck
                                      ? formValues.primaryContact === null ||
                                        formValues.primaryContact === 'undefined'
                                        ? ''
                                        : formValues.primaryContact
                                      : formValues.primaryWhatsApp === null ||
                                        formValues.primaryWhatsApp === 'undefined'
                                        ? ''
                                        : formValues.primaryWhatsApp
                                  }
                                  onChange={(e) => {
                                    handleChange(e, 41);
                                  }}
                                  type='text'
                                />
                              </div>
                            </FormGroup>
                            <FormGroup className='common-checkbox-group'>
                              <Input
                                type='checkbox'
                                className='common-checkbox-input ml-0'
                                placeholder='Type Here'
                                checked={isMobileCheck}
                                value={isMobileCheck}
                                onChange={(e) => setIsmobileCheck(!isMobileCheck)}
                              />
                              <Label className='common-input-label mb-0'>
                                Same as Mobile Number<span className='required'></span>
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col md={4} className='common-group'>
                            <FormGroup>
                              <Label className='common-input-label'>
                                Email<span className='required'>*</span>
                              </Label>
                              <Input
                                required
                                className='common-input'
                                type='email'
                                autoComplete='off'
                                name='email'
                                value={
                                  formValues.email === null ||
                                    formValues.email === 'undefined'
                                    ? ''
                                    : formValues.email
                                }
                                onChange={(e) => {
                                  handleChange(e, 4);
                                }}
                                placeholder='Type Here'
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <div className='common-buttons d-flex flex-wrap align-items-center justify-content-center'>
                              {isKycRequired ? (
                                <CommonButton name={'Cancel'} btnClass={'btnSecondary'} type="button" onClick={handleBack} />
                              ) : (
                                <CommonButton name={'Save as Draft'} btnClass={'btnSecondary'} type="button" onClick={handleSaveAsDraft} />
                              )}
                              <CommonButton name={'Submit'} btnClass={'btnPrimary'} type="submit" />
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </div>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrimaryContactInformation;
